<template>
  <div :style="{ '--animate-duration': duration }">
    <slot />
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      duration: {
        type: String,
        required: true,
      },
    },
  })
</script>
